var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSharePurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4998 18.8223C47.5038 18.8223 50.7498 15.6622 50.7498 11.7639C50.7498 7.86571 47.5038 4.70557 43.4998 4.70557C39.4957 4.70557 36.2498 7.86571 36.2498 11.7639C36.2498 15.6622 39.4957 18.8223 43.4998 18.8223Z",
    fill: "white",
    stroke: "#733FE7",
    strokeWidth: 4.33575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5002 35.292C18.5043 35.292 21.7502 32.1319 21.7502 28.2337C21.7502 24.3354 18.5043 21.1753 14.5002 21.1753C10.4962 21.1753 7.25024 24.3354 7.25024 28.2337C7.25024 32.1319 10.4962 35.292 14.5002 35.292Z",
    fill: "white",
    stroke: "#733FE7",
    strokeWidth: 4.33575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4998 51.7613C47.5038 51.7613 50.7498 48.6011 50.7498 44.7029C50.7498 40.8047 47.5038 37.6445 43.4998 37.6445C39.4957 37.6445 36.2498 40.8047 36.2498 44.7029C36.2498 48.6011 39.4957 51.7613 43.4998 51.7613Z",
    fill: "white",
    stroke: "#733FE7",
    strokeWidth: 4.33575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7593 31.7864L37.2651 41.1505",
    stroke: "#733FE7",
    strokeWidth: 4.33575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2409 15.3167L20.7593 24.6808",
    stroke: "#733FE7",
    strokeWidth: 4.33575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePurple);
export default __webpack_public_path__ + "static/media/share-purple.4bc874a4.svg";
export { ForwardRef as ReactComponent };